import { type FC } from 'react'

import { ShowAtOrLarger } from '@/components/shared/breakpoint'

import { LoadingBlockContainer } from '../srp-loading/LoadingBlockContainer'
import { SrpResults } from './results'
import { SrpSort } from './sort'
import { SrpResultsSortContainer } from './styled'

type SrpResultsSortProps = {
  loading?: boolean
}

export const SrpResultsSort: FC<SrpResultsSortProps> = ({ loading = false }) => {
  return (
    <>
      {loading ? (
        <LoadingBlockContainer variant="inline" width="100%" height="4.65rem" bottom="0px" />
      ) : (
        <SrpResultsSortContainer>
          <>
            <ShowAtOrLarger breakpoint="large">
              <SrpResults />
            </ShowAtOrLarger>
            <SrpSort />
          </>
        </SrpResultsSortContainer>
      )}
    </>
  )
}
